var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-carousel-item m-auto d-flex align-items-center justify-content-center"},[_c('img',{staticClass:"p-2 company-logo",attrs:{"src":_vm.imageUrl,"alt":_vm.imageAlt}})])}
var staticRenderFns = []

export { render, staticRenderFns }